import { KeyboardArrowUp } from "@mui/icons-material";
import clsx from "clsx";
import { FC } from "react";

import { IRichLogData, useHaveCustomPermissions } from "@ryde/shared";

import { useProductionLogFiltersFooter } from "../hooks/use-production-log.filters.footer";
import { ProductionLogsStatsTabs } from "./production-logs.stats.tabs";

interface IProductionLogsStatsWrapper {
  logData: IRichLogData | undefined;
  filteredLogsCount: number | undefined;
  isStatsCollapsed: boolean;
  onToggleStats: () => void;
}

export const ProductionLogsStatsWrapper: FC<IProductionLogsStatsWrapper> = ({
  logData,
  filteredLogsCount,
  isStatsCollapsed,
  onToggleStats,
}) => {
  const { hasReadSystemParamsPermission } = useHaveCustomPermissions();

  const {
    timeInfoText,
    timeInfoClassName,
    duration,
    hasValidTimes,
    formattedStartedAt,
    formattedProducedRideFirstDate,
    formattedProducedRideEndDate,
    hasProductionData,
    currentPage,
    totalPages,
    fetchLogs,
    handleClearProductionCacheClick,
    producedRideCount,
    joinedRideCount,
    systemParams,
  } = useProductionLogFiltersFooter({ logData, filteredLogsCount });

  return (
    <div
      className={clsx("log__stats-panel", {
        collapsed: isStatsCollapsed,
      })}
    >
      <button
        type="button"
        className={clsx("log__panel-collapse-btn", {
          collapsed: isStatsCollapsed,
        })}
        onClick={onToggleStats}
        title={isStatsCollapsed ? "Expand statistics" : "Collapse statistics"}
      >
        <KeyboardArrowUp fontSize="small" />
      </button>
      <div
        className={clsx("log__panel-content", {
          collapsed: isStatsCollapsed,
        })}
      >
        <ProductionLogsStatsTabs
          state={logData?.state}
          productionFilters={logData?.productionFilters}
          timeInfoText={timeInfoText}
          timeInfoClassName={timeInfoClassName}
          duration={duration}
          hasValidTimes={hasValidTimes}
          formattedStartedAt={formattedStartedAt}
          formattedProducedRideFirstDate={formattedProducedRideFirstDate}
          formattedProducedRideEndDate={formattedProducedRideEndDate}
          hasProductionData={hasProductionData}
          currentPage={currentPage}
          totalPages={totalPages}
          filteredLogsCount={filteredLogsCount}
          fetchLogs={fetchLogs}
          handleClearProductionCacheClick={handleClearProductionCacheClick}
          producedRideCount={producedRideCount}
          joinedRideCount={joinedRideCount}
          hasReadSystemParamsPermission={hasReadSystemParamsPermission}
          systemParams={systemParams}
        />
      </div>
    </div>
  );
};
